import React, { useEffect, useState } from 'react';
import Home from '../src/Pages/Home/Home';
import AiChat from '../src/Pages/AiChat/AiChat';
import AiPublicChat from './Pages/AiChat/AiPublicChat';
import Searchp from '../src/Pages/Search/Search';
import Youtube from './Pages/Youtube/Youtube';
import Settings from './Pages/Settings/Settings';
import Top10 from '../src/Pages/Top10/Top10';
import Signin from '../src/Pages/Auth/Signin/Signin';
import PrivacyPolicy from './Pages/PrivacyPolicyPage';
import EmailConfirmation from './Pages/Auth/EmailConfirmation/EmailConfirmation';
import Portfolio from './Pages/Portfolio/Portfolio';
import "./i18n";
import "./nextstock-premium.css";

const validPages = ['Signin', 'Home', 'ai-chat', 'next-stock-ai-public-chat', 'Searchp', 'Top10', 'Youtube', 'Settings', 'PrivacyPolicy', 'AccountConfirmation', 'Portfolio'];

export default function App() {
  const [currentPage, setCurrentPage] = useState('Signin');

  // Keep the existing animated backdrop, but stop GPU work when the user is idle
  // or the tab is hidden. Resume on interaction without restarting the animation.
  useEffect(() => {
    const root = document.documentElement;
    let idleTimer;
    let lastActivity = 0;
    const pause = () => root.classList.add('ns-ambient-idle');
    const resume = () => {
      if (document.hidden) return pause();
      const now = Date.now();
      if (now - lastActivity < 1200) return;
      lastActivity = now;
      root.classList.remove('ns-ambient-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(pause, 12000);
    };
    const onVisibility = () => document.hidden ? pause() : resume();
    const events = ['pointermove', 'pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resume, { passive: true }));
    document.addEventListener('visibilitychange', onVisibility);
    resume();
    return () => {
      clearTimeout(idleTimer);
      events.forEach(event => window.removeEventListener(event, resume));
      document.removeEventListener('visibilitychange', onVisibility);
      root.classList.remove('ns-ambient-idle');
    };
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'Signin':
        return <Signin setPage={handlePages} />;
      // case 'Signup':
      //   return <Signup setPage={handlePages} />;
      case 'Home':
        return <Home setPage={handlePages} />;
      case 'Searchp':
        return <Searchp setPage={handlePages} />;
      case 'ai-chat':
        return <AiChat setPage={handlePages} />;
      case 'Portfolio':
        return <Portfolio setPage={handlePages} />;
      case 'Youtube':
        return <Youtube setPage={handlePages} />;
      case 'Settings':
        return <Settings setPage={handlePages} />;
      case 'Top10':
        return <Top10 setPage={handlePages} />;
      case 'AccountConfirmation':
        return <EmailConfirmation setPage={handlePages} />;
      case 'PrivacyPolicy':
        return <PrivacyPolicy setPage={handlePages} />;
      case 'next-stock-ai-public-chat':
        return <AiPublicChat setPage={handlePages} />;
      default:
        return <Home setPage={handlePages} />; // Fallback to Home if the page is invalid
    }
  };

  const handlePages = (page) => {
    if (validPages.includes(page)) {
      setCurrentPage(page);
      if (window.matchMedia('(max-width: 760px)').matches) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      window.history.replaceState(null, '', `${window.location.pathname}?page=${encodeURIComponent(page)}`);
    } else {
      setCurrentPage('Home');
      if (window.matchMedia('(max-width: 760px)').matches) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      window.history.replaceState(null, '', `${window.location.pathname}?page=Home`);
    }
  };

  return <div className="app-container">{renderPage()}</div>;
}

